import type { DataTableRow } from "@etudescarre/ui";
import { DataTable } from "@etudescarre/ui";
import { isNotNil } from "@etudescarre/utils";
import { ClasseurFilterBar } from "./classeur-filter-bar";
import type { ClasseurProps } from "./types";

export function Classeur<T extends DataTableRow>({
  title,
  items,
  columns,
  filters,
  onFilterChange,
  activeFilters,
  isLoading,
  emptyMessage,
  total,
  actions,
  onRowClick,
  getRowClassName,
}: ClasseurProps<T>) {
  return (
    <div className="flex h-full flex-col">
      <div className="flex items-start justify-between gap-4 border-b border-zinc-200 px-4 py-4 dark:border-zinc-700">
        <div>
          <h2 className="text-lg font-semibold text-zinc-900 dark:text-zinc-100">
            {title}
          </h2>
          {isNotNil(total) && (
            <p className="mt-1 text-sm text-zinc-500">
              {total} {total > 1 ? "éléments" : "élément"}
            </p>
          )}
        </div>
        {isNotNil(actions) && <div>{actions}</div>}
      </div>

      <ClasseurFilterBar
        filters={filters}
        activeFilters={activeFilters}
        onFilterChange={onFilterChange}
      />

      <div className="flex-1 overflow-auto">
        <DataTable
          columns={columns}
          data={items}
          isLoading={isLoading}
          dense
          stickyHeader
          onRowClick={onRowClick}
          getRowClassName={getRowClassName}
          emptyState={
            <div className="py-12 text-center text-sm text-zinc-500">
              {emptyMessage}
            </div>
          }
          isEmpty={items.length === 0 && !isLoading}
        />
      </div>
    </div>
  );
}
